import React from "react";
import { SkeletonText } from "./SkeletonBox";

/**
 * CategoryPageSkeleton - Non-animated skeleton for Categories/Genres parent listing page
 * 
 * Matches layout of:
 * - categories/content.js (CategoriesSlider with wrapped category tiles)
 * - categoryList.js (Category tiles: 20% width, 130px min-height)
 */

function skeletonElement(className) {
  return function SkeletonElement(props) {
    var mergedClassName = className + (props.className ? " " + props.className : "");
    return <div {...props} className={mergedClassName} />;
  };
}

var Container = skeletonElement("legacy-skeleton-page-container");
var ScrollingArea = skeletonElement("legacy-skeleton-category-scroll");
var SectionTitle = skeletonElement("legacy-skeleton-category-title");
var TilesGrid = skeletonElement("legacy-skeleton-tiles-grid");
var TileWrapper = skeletonElement("legacy-skeleton-tile-wrapper");
var TileSkeleton = skeletonElement("legacy-skeleton-tile");
var TileContent = skeletonElement("legacy-skeleton-tile-content");

/**
 * Category Tiles Grid Skeleton
 */
function CategoryTilesGridSkeleton({ count = 10 }) {
  var tiles = [];
  for (var i = 0; i < count; i++) {
    tiles.push(
      <TileWrapper key={"tile_" + i}>
        <TileSkeleton>
          <TileContent>
            <SkeletonText width={100} size="lg" style={{ marginBottom: 8 }} />
            <SkeletonText width={60} size="sm" />
          </TileContent>
        </TileSkeleton>
      </TileWrapper>
    );
  }
  
  return (
    <TilesGrid>
      {tiles}
    </TilesGrid>
  );
}

/**
 * Section with title and grid
 */
function CategorySectionSkeleton({ tileCount = 10 }) {
  return (
    <div>
      <SectionTitle />
      <CategoryTilesGridSkeleton count={tileCount} />
    </div>
  );
}

/**
 * CategoryPageSkeleton - Main export
 */
function CategoryPageSkeleton({ showCategories = true, showGenres = true }) {
  return (
    <Container>
      <ScrollingArea>
        {showCategories && <CategorySectionSkeleton tileCount={10} />}
        {showGenres && <CategorySectionSkeleton tileCount={15} />}
      </ScrollingArea>
    </Container>
  );
}

export { CategoryTilesGridSkeleton, CategorySectionSkeleton };
export default CategoryPageSkeleton;
